import { init, RematchDispatch, RematchRootState } from '@rematch/core';
import persistPlugin from '@rematch/persist';
import storage from 'redux-persist/lib/storage'
import { models, RootModel } from './models';

const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['Locations']
}

export const store = init({
    models,
    // @ts-ignore
    plugins: [persistPlugin(persistConfig)],
    
    devtoolOptions: {
        disabled: true,
    },
    
})

export type Store = typeof store
export type Dispatch = RematchDispatch<RootModel>
export type RootState = RematchRootState<RootModel>